<template>
  <div class="big-image-container">
    <div class="compare-list">
      <!--<ul class="time-list">
        <li class="time-content">{{primevalImage.time | filterTime}}</li>
        <li class="compare-item" :class="{active: primevalImage.active === true}"
            @click="imageClick(primevalImage)" @dblclick="imageDblclick(primevalImage)">
          <div class="item">
            <img
              :src="imageSrcPrefixThumbnails + primevalImage.path" alt="" @load="imageOnload">
            <div class="title">{{primevalImage.position_detail}}</div>
          </div>
        </li>
      </ul>-->
      <ul class="time-list" v-for="(item, index) in compareImageList" :key="index">
        <li class="time-content" v-if="item.type === 'hairdressing'">{{item.treat_no}}</li>
        <li class="time-content" v-else>{{item.time | filterTime}}</li>
        <li
          class="compare-item"
          v-for="(imgItem, index1) in item.images"
          :key="index1"
          :class="{active:
            imgItem.active === true}"
          @click="imageClick(imgItem)"
          @dblclick="imageDblclick(imgItem)"
        >
          <div class="item">
            <img :src="imgItem.thumbnailsImageSrc" alt @load="imageOnload">
            <div class="title" v-if="item.type === 'hairdressing'"
                 style="display: flex;justify-content:space-between;font-size: 13px">
              <div>{{imgItem.status}}</div>
              <div>{{imgItem.created_time | filterTime2}}</div>
            </div>
            <div class="title" v-else>{{imgItem.position_detail}}</div>
          </div>
        </li>
      </ul>
    </div>
    <div class="big-image" v-if="isCompareImage === 1">
      <div class="bg"></div>
      <lookImage
        :imageClickToggle="imageClickToggle"
        :largeImgage="largeImgage"
        :info="activeImage"
        :selected="true"
        v-on:getImgSrc="getImgSrc"
      ></lookImage>
    </div>
    <div class="big-image-compare" v-if="isCompareImage === 2">
      <div class="bg"></div>
      <div class="big-image-compare-item" @click="checkImageCompile(true)">
        <lookImage
          :largeImgage="largeImgage"
          :imageCompileClass="imageCompileClass"
          :selected="selected"
          :isCompareImage="isCompareImage"
          :info="activeImage"
        ></lookImage>
      </div>
      <div class="big-image-compare-item" @click="checkImageCompile(false)">
        <lookImage2
          :largeImgage="largeImgage2"
          :imageCompileClass="imageCompileClass2"
          :selected="selected2"
          :isCompareImage="isCompareImage"
          :info="activeImage2"
        ></lookImage2>
      </div>
    </div>
    <div class="cut-off-rule"></div>
  </div>
</template>

<script>
import lookImage from "./lookImage";
import lookImage2 from "./lookImage2";
import api from "../api";
import moment from "moment";
export default {
  name: "",
  components: {
    lookImage,
    lookImage2
  },
  props: {
    primevalImage: Object,
    compareImageList: Array,
    isCompareImage: Number,
    largeImgage: String,
    largeImgage2: String,
    imageCompileClass: String,
    imageCompileClass2: String,
    selected: Boolean,
    selected2: Boolean,
    activeImage: Object,
    activeImage2: Object
  },
  data() {
    return {
      imageSrcPrefix: api.imageSrcPrefix,
      imageSrcPrefixThumbnails: api.imageSrcPrefixThumbnails,
      imageClickToggle: true,
    };
  },
  methods: {
    imageClick(data) {
      this.$emit("imageClick", data);
      this.imageClickToggle = !this.imageClickToggle;
    },
    imageDblclick(data) {
      this.$emit("imageDblclick", data);
    },
    imageOnload(e) {
      this.$emit("imageOnload", e);
    },
    checkImageCompile(data) {
      this.$emit("checkImageCompile", data);
    },
    getImgSrc(data) {
      this.$emit("getImgSrc", {
        imgData: data.imgData,
        currentImg: data.currentImg
      });
    }
  },
  filters: {
    filterTime(time) {
      if (time) {
        return moment(time).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return '';
      }
    },
    filterTime2(time) {
      if (time) {
        return moment(time).format("YYMMDD-HH:mm:ss");
      } else {
        return '';
      }
    },
  }
};
</script>

<style lang="less">
/*::-webkit-scrollbar {*/
  /*width: 5px;*/
  /*height: 100%;*/
/*}*/

/*::-webkit-scrollbar-track-piece {*/
  /*background: #fff;*/
  /*-webkit-border-radius: 6px;*/
/*}*/

/*::-webkit-scrollbar-thumb:vertical {*/
  /*background-color: #61a2bf;*/
  /*-webkit-border-radius: 6px;*/
/*}*/
.big-image-container {
  display: flex;
  justify-content: flex-start;
  position: relative;
  width: 100%;
  height: 900px;
  .big-image {
    position: absolute;
    left: 230px;
    right: 0;
    top: 0;
    /*width: 1600px;*/
    height: 900px;
    .bg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 826px;
      background-color: #000;
    }
  }
  .big-image-compare {
    position: absolute;
    left: 230px;
    right: 0;
    top: 0;
    /*width: 1600px;*/
    display: flex;
    justify-content: space-between;
    .big-image-compare-item {
      /*width: 790px;*/
      width: 49%;
    }
    .bg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 826px;
      background-color: #000;
    }
  }
  .compare-list {
    width: 200px;
    margin-right: 30px;
    overflow-y: auto;
    z-index: 1;
    .time-list {
      margin-bottom: 15px;
      .time-content {
        width: 180px;
        color: #000;
        margin-bottom: 5px;
        font-size: 16px;
        font-weight: bold;
        text-align: center;
      }
      .compare-item {
        width: 160px;
        height: 130px;
        padding: 10px;
        border-radius: 3px;
        box-shadow: 2px 2px 3px #888;
        background-color: #e1e1e1;
        .item {
          width: 160px;
          height: 130px;
          position: relative;
          overflow: hidden;
          .title {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 30px;
            color: #ffffff;
            background-color: rgba(0, 0, 0, 0.3);
            font-size: 16px;
            text-align: center;
            line-height: 30px;
            user-select: none;
          }
        }
      }
      .compare-item + .compare-item {
        margin-top: 10px;
      }
      .compare-item.active {
        background-color: #61a2bf;
      }
    }
  }
  .cut-off-rule {
    position: absolute;
    left: 197px;
    top: 0;
    width: 1px;
    height: 100%;
    background-color: #61a2bf;
  }
}
</style>
